import { DocumentsItem } from "@/types/generated/DifcamWebTypes";

import { BaseService } from "./BaseService";

export class DocumentsService extends BaseService {
  getDocumentsItems(): Promise<DocumentsItem[]> {
    return this.get<DocumentsItem[]>(`/document`);
  }
}
